module.exports =  {
                    NETWORK_ERROR: "NETWORK_ERROR"
                  }
